module.exports = __webpack_public_path__ + "img/card_icon.81d7ac1d.png";